const ASSET_BASE_URL = process.env.NEXT_PUBLIC_ASSET_BASE_URL || "";

export function getAssetUrl(path: string): string {
  return `${ASSET_BASE_URL}${path}`;
}
